/**
 * 生成指定数量的随机颜色
 * @param {number} count - 需要生成的颜色数量
 * @returns {string[]} 包含随机颜色的数组，颜色格式为#RRGGBB
 */
function generateRandomColors(count) {
    // 验证输入是否为有效数字
    if (typeof count !== 'number' || count <= 0 || !Number.isInteger(count)) {
        throw new Error('请传入一个正整数作为颜色数量');
    }

    const colors = [];
    // 生成count个随机颜色
    for (let i = 0; i < count; i++) {
        // 生成0-255之间的随机整数作为RGB值
        const red = Math.floor(Math.random() * 256);
        const green = Math.floor(Math.random() * 256);
        const blue = Math.floor(Math.random() * 256);

        // 将RGB值转换为十六进制并补零，确保每个颜色分量为两位
        const redHex = red.toString(16).padStart(2, '0');
        const greenHex = green.toString(16).padStart(2, '0');
        const blueHex = blue.toString(16).padStart(2, '0');

        // 组合成完整的颜色字符串
        const color = `#${redHex}${greenHex}${blueHex}`;
        colors.push(color);
    }

    return colors;
}
export default generateRandomColors;
// 使用示例：
try {
    // 生成5个随机颜色
    const colors = generateRandomColors(5);
    console.log('生成的随机颜色：', colors);
} catch (error) {
    console.error(error.message);
}
